import $ from "jquery";
import CookieConsent from "@alpaga/cookie-consent";
$(document).ready(function () {
    var lang = $("html").attr("lang") == "de-DE" ? "de" : ($("html").attr("lang") == "fr-BE" ? "fr" : "en");
    var cookies = {
        fr: {
            locale: "fr",
            content: {
                link: "/fr/mentions-legales-et-protection-de-la-vie-privee/",
                banner: {
                    title: "En utilisant ce site, vous acceptez l'utilisation des cookies."
                },
                popup: {
                    title: "Ce site utilise des cookies.",
                    description: "Ce site utilise des cookies. Nous utilisons des cookies pour que notre site web fonctionne au mieux, améliorant ainsi votre expérience en ligne. Afin d’en savoir plus sur l’utilisation des cookies, les plug-ins pour les réseaux sociaux ainsi que le web tracking, n’hésitez pas à consulter notre page d’informations sur les Cookies ainsi que notre Déclaration de Protection des Données."
                }
            },
            labels: {
                showCookie: "Afficher les cookies",
                table: {
                    name: "Nom",
                    provider: "Fournisseur",
                    purpose: "Objectif",
                    expiry: "Expire",
                    type: "Type"
                },
                "switch": {
                    on: "Oui",
                    off: "Non"
                },
                actions: {
                    more: "En savoir plus ?",
                    allow: {
                        all: "Accepter tous les cookies",
                        selected: "Accepter tous les cookies sélectionnés"
                    },
                    read: {
                        policy: "Lire notre politique de cookie"
                    },
                    cancel: "Annuler",
                    view: {
                        advanced: "Choix avancé",
                        simple: "Choix simple"
                    }
                }
            },
            cookies: {
                'necessary': {
                    name: "necessary",
                    disabled: true,
                    value: true,
                    title: "Cookies nécessaires",
                    description: "Les cookies nécessaires aident à rendre un site Web utilisable en activant de base des fonctions telles que la navigation sur les pages et l'accès aux zones sécurisées du site Web. Le site Web ne peut pas fonctionner correctement sans ces cookies.",
                    "function": function () { },
                    cookies: [
                        {
                            name: "CookieConsent",
                            provider: "cookieconsent.extension",
                            purpose: "Stocke l'état de consentement des cookies de l'utilisateur pour le domaine actuel",
                            expiry: "1 an",
                            type: "HTTP"
                        },
                    ]
                },
                analytics: {
                    name: "analytics",
                    value: true,
                    title: "Analytics Cookies",
                    "function": function () {
                        analyticsFn();
                    },
                    description: "Les cookies analytiques aident les propriétaires de sites Web à comprendre comment les visiteurs \
                    interagissent avec les sites Web en collectant et en signalant des informations de manière anonyme.",
                    cookies: [
                        {
                            name: "_ga",
                            provider: "Google",
                            purpose: "Enregistre un identifiant unique utilisé pour générer des données statistiques sur la façon dont le visiteur utilise le site Web.",
                            expiry: "2 ans",
                            type: "HTTP"
                        },
                        {
                            name: "_gat",
                            provider: "Google",
                            purpose: "Utilisé par Google Analytics pour réduire le taux de demandes",
                            expiry: "1 jour",
                            type: "HTTP"
                        },
                        {
                            name: "_gid",
                            provider: "Google",
                            purpose: "Enregistre un identifiant unique utilisé pour générer des données statistiques sur la façon dont le visiteur utilise le site Web.",
                            expiry: "1 jour",
                            type: "HTTP"
                        }
                    ]
                }
            }
        },
        en: {
            locale: "en",
            content: {
                link: "/en/legal-notice-and-privacy-policy/",
                banner: {
                    title: "By using this site, you agree to the use of cookies."
                },
                popup: {
                    title: "This site uses cookies.",
                    description: "This site uses cookies. We use cookies to make our website work better, enhancing your online experience. To learn more about the use of cookies, social networking plug-ins and web tracking, please see our Cookie Information page and our Data Protection Statement."
                }
            },
            labels: {
                showCookie: "Show cookies",
                table: {
                    name: "Name",
                    provider: "Provider",
                    purpose: "Purpose",
                    expiry: "Expiry",
                    type: "Type"
                },
                "switch": {
                    on: "On",
                    off: "Off"
                },
                actions: {
                    more: "Want to know more?",
                    allow: {
                        all: "Allow all cookies",
                        selected: "Allow selected cookies"
                    },
                    read: {
                        policy: "Read our Cookie Policy"
                    },
                    cancel: "Cancel",
                    view: {
                        advanced: "Advanced cookie choices",
                        simple: "Simple cookie choices"
                    }
                }
            },
            cookies: {
                'necessary': {
                    name: "necessary",
                    disabled: true,
                    value: true,
                    title: "Necessary Cookies",
                    description: "Necessary cookies help make a website usable by enabling basic\
                    functions like page navigation and access to secure areas of the website. The website cannot\
                    function properly without these cookies.",
                    "function": function () { },
                    cookies: [
                        {
                            name: "CookieConsent",
                            provider: "cookieconsent.extension",
                            purpose: "Stores the user's cookie consent state for the current domain",
                            expiry: "1 year",
                            type: "HTTP"
                        },
                    ]
                },
                analytics: {
                    name: "analytics",
                    value: true,
                    title: "Analytics Cookies",
                    "function": function () {
                        analyticsFn();
                    },
                    description: "Analytic cookies help website owners to understand how visitors\
                    interact with websites by collecting and reporting information anonymously.",
                    cookies: [
                        {
                            name: "_ga",
                            provider: "Google",
                            purpose: "Registers a unique ID that is used to generate statistical data on how the visitor uses the website.",
                            expiry: "2 years",
                            type: "HTTP"
                        },
                        {
                            name: "_gat",
                            provider: "Google",
                            purpose: "Used by Google Analytics to throttle request rate",
                            expiry: "1 day",
                            type: "HTTP"
                        },
                        {
                            name: "_gid",
                            provider: "Google",
                            purpose: "Registers a unique ID that is used to generate statistical data on how the visitor uses the website.",
                            expiry: "1 day",
                            type: "HTTP"
                        }
                    ]
                }
            }
        },
        de: {
            locale: "de",
            content: {
                link: "/de/rechtliche-hinweise-und-datenschutz/",
                banner: {
                    title: "Dur ch die Nutzung dieser Website erklären Sie sich mit der Verwendung von Cookies einverstanden."
                },
                popup: {
                    title: "Diese Seite verwendet Cookies.",
                    description: "Diese Seite verwendet Cookies. Wir verwenden Cookies, damit unsere Website besser funktioniert und Ihr Online-Erlebnis verbessert wird. Um mehr über die Verwendung von Cookies, Plug-ins für soziale Netzwerke und Web-Tracking zu erfahren, lesen Sie bitte unsere Cookie-Informationsseite und unsere Datenschutzerklärung."
                }
            },
            labels: {
                showCookie: "Cookies anzeigen",
                table: {
                    name: "Name",
                    provider: "Lieferant",
                    purpose: "Ziel",
                    expiry: "Läuft ab",
                    type: "Typ"
                },
                "switch": {
                    on: "Ja",
                    off: "Nein"
                },
                actions: {
                    more: "Willst du mehr wissen?",
                    allow: {
                        all: "Akzeptiere alle Cookies",
                        selected: "Alle ausgewählten Cookies akzeptieren"
                    },
                    read: {
                        policy: "Lesen Sie unsere Cookie-Richtlinie"
                    },
                    cancel: "Abbrechen",
                    view: {
                        advanced: "Erweiterte Auswahl",
                        simple: "Einfache Wahl"
                    }
                }
            },
            cookies: {
                'necessary': {
                    name: "necessary",
                    disabled: true,
                    value: true,
                    title: "Notwendige Cookies",
                    description: "Notwendige Cookies helfen, eine Website nutzbar zu machen, indem sie grundlegende Funktionen wie die Seitennavigation und den Zugriff auf sichere Bereiche der Website. Ohne diese Cookies kann die Website nicht richtig funktionieren.",
                    "function": function () { },
                    cookies: [
                        {
                            name: "CookieConsent",
                            provider: "cookieconsent.extension",
                            purpose: "Speichert den Cookie-Zustimmungsstatus des Benutzers für die aktuelle Domain",
                            expiry: "1 jahr",
                            type: "HTTP"
                        },
                    ]
                },
                analytics: {
                    name: "analytics",
                    value: true,
                    title: "Analytische Cookies",
                    "function": function () {
                        analyticsFn();
                    },
                    description: "Analytische Cookies helfen Website-Besitzern zu verstehen, wie Besucher mit Websites interagieren, indem sie mit Websites interagieren, indem sie Informationen anonymisiert sammeln und melden.",
                    cookies: [
                        {
                            name: "_ga",
                            provider: "Google",
                            purpose: "Speichert eine eindeutige Kennung, die verwendet wird, um statistische Daten darüber zu generieren, wie der Besucher die Website nutzt",
                            expiry: "2 jahre",
                            type: "HTTP"
                        },
                        {
                            name: "_gat",
                            provider: "Google",
                            purpose: "Wird von Google Analytics verwendet, um die Rate der Anfragen zu reduzieren",
                            expiry: "1 tag",
                            type: "HTTP"
                        },
                        {
                            name: "_gid",
                            provider: "Google",
                            purpose: "Speichert eine eindeutige Kennung, die verwendet wird, um statistische Daten darüber zu generieren, wie der Besucher die Website nutzt",
                            expiry: "1 tag",
                            type: "HTTP"
                        }
                    ]
                }
            }
        }
    };
    var CookieConsentNode = new CookieConsent(cookies[lang]);
    CookieConsentNode.init();
});
